import { AiFillCaretDown } from "react-icons/ai";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { Link } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Example() {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="inline-flex uppercase items-center w-full justify-center gap-x-1.5 text-[16px]  text-white">
          <div className="navLi">
            <p className="navlink">Blog</p>
          </div>
          {/* <Aiwhite
            uppercasetDown
            whitelassName="-mr-1 h-5 w-3 text-gray-9[15px]"
            aria-hidden="true"
          /> */}
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute left-0 z-10 mt-2 w-40 origin-top-right rounded-md dropdown shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <Link
                  to="/blog"
                  className={classNames(
                    active ? "text-white uppercase" : "text-white",
                    "block px-4 py-4 text-[15px]"
                  )}
                >
                  Blog
                </Link>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <Link
                  to="/blogdetail"
                  className={classNames(
                    active ? "text-white uppercase" : "text-white",
                    "block px-4 py-4 text-[15px]"
                  )}
                >
                  Blog Details
                </Link>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <Link
                  to="/element"
                  className={classNames(
                    active ? "text-white uppercase" : "text-white",
                    "block px-4 py-4 text-[15px]"
                  )}
                >
                  element
                </Link>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
